// Lazy load of the task form's reference lists (engineers, work types), shared by the
// map and the tracker sections. `vm` must own `engineers` and `workTypes` resources.
import * as api from './api';
import { loadResource, isReady } from './resource';
import { notifyError } from './notify';

// Fetchers are wrapped so the api functions are read at call time (jest automocks are replaced per test).
const REFERENCES = [
  ['engineers', 'исполнители', () => api.getFieldEngineers()],
  ['workTypes', 'виды работ', () => api.getWorkTypes()],
];

/** Resolves true when both lists are ready; otherwise toasts what failed and resolves false. */
export async function ensureReferences(vm) {
  await Promise.all(REFERENCES
    .filter(([key]) => !isReady(vm[key]))
    .map(([key, , fetch]) => loadResource(vm[key], fetch)));
  const failed = REFERENCES.filter(([key]) => !isReady(vm[key])).map(([, label]) => label);
  if (failed.length) {
    notifyError(vm, `Не удалось загрузить: ${failed.join(', ')}`);
    return false;
  }
  return true;
}
